import axiosInstance from '../utils/axiosConfig';

const BASE_URL = '/api/stock';

const stockpileService = {
  getStockpile: async (variantId, { limit = 5, includeSeries = false, days = 30 } = {}) => {
    const params = { limit };
    if (includeSeries) {
      params.include_series = 1;
      params.days = days;
    }
    const response = await axiosInstance.get(
      `${BASE_URL}/variants/${variantId}/stockpile/`,
      { params }
    );
    return response.data;
  },

  getDashboard: async ({ days = 30, category, productType, q } = {}) => {
    // Skip empty filter params so the backend default (no filter) kicks in
    // and we don't push noisy `?category=&product_type=` into the URL.
    const params = { days };
    if (category) params.category = category;
    if (productType) params.product_type = productType;
    if (q) params.q = q;
    const response = await axiosInstance.get(`${BASE_URL}/stockpile/dashboard/`, {
      params,
    });
    return response.data;
  },

  postMovement: async (variantId, payload) => {
    const response = await axiosInstance.post(
      `${BASE_URL}/variants/${variantId}/stockpile/movements/`,
      payload
    );
    return response.data;
  },

  voidMovement: async (movementId, reason = '') => {
    const response = await axiosInstance.post(
      `${BASE_URL}/movements/${movementId}/void/`,
      { reason }
    );
    return response.data;
  },
};

export default stockpileService;
